export default __webpack_public_path__ + "static/media/heart.9b67fb50.webp";